module.exports = __webpack_public_path__ + "first-500_ir.jpg?ffdb581627d5fd3bafe268a9107f0115";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500_ir.jpg
// module id = 556
// module chunks = 0